export default __webpack_public_path__ + "static/media/whychooseicon1.eee65434.png";